<template>
  <div>
      <div class="daylist" v-for="(item,i) in list" :key="i">
          <div class="dayNumber">D{{i+1}}</div>
          <div class="dayContent"> 
             <div class="adresslist">
                 <!-- 行程名称、车程、用餐、住宿、徒步、海拔
                 title content accommodation driving restaurant foot altitude
                 行程名称、行程富文本, 住宿、车程、用餐、徒步、海拔
                 1\ -->
                 <span>{{item.title}}</span>

                
             </div>
             <div class="daycontent"  v-html="getcont(item.content)">
                   {{item.driving}}
             </div>
             <div  class="daydriving">
                 <div style="display:flex;">
                    <p v-if="item.altitude" style="flex:1">
                        <i class="el-wu-driving"></i><span>车程：</span>&nbsp;{{item.driving}}
                    </p>
                    <p v-if="item.altitude" style="flex:1">
                        <i class="el-wu-restaurant"></i><span>住宿：</span>&nbsp;{{item.accommodation}}
                    </p>
                 </div>
                <p v-if="item.altitude" style="flex:1">
                        <i class="el-wu-accommodation"></i>
                        <span>用餐：</span>&nbsp;{{item.restaurant}}
                    </p>
                <div style="display:flex;">
                   

                    <p v-if="item.altitude"  style="flex:1">
                        <i class="el-wu-altitude"></i><span>海拔：</span>
                        &nbsp;{{item.altitude}}
                    </p>
                    <p v-if="item.altitude" style="flex:1">
                        <i class="el-wu-foot"></i><span>徒步：</span>&nbsp;{{item.foot}}</p>
                </div>
                
              
             </div>
             
          </div>
      </div>
  </div>
</template>

<script>

  export default {
    name:'',
    props:['list'],
    data () {
      return {

      };
    },
    computed: {
       
    },

    mounted() {},

    methods: {
        getcont(content=""){
            if (content) {
                // width:auto; display:block; white-space:pre-wrap;word-wrap : break-word ;
                // var text=content.replace(/<span style="/gi, '<span style="width:auto; display:block; white-space:pre-wrap;word-wrap : break-word;  ');
                 return content.replace(/<img/gi, '<img style="max-width:100%;height:auto;" ');

            } else {
                return ""
            }
           
        }
    },

  }

</script>
<style lang='scss' scoped>
.daylist{
    display: flex;
    width: 1200px;
    margin-top:15px ;
    .dayNumber{
        width: 45px;
        height: 45px;
        background: #ff7c00;
        border-radius: 50%;
        text-align: center;
        line-height: 45px;
        color: #fff;
    }
    .dayContent{
        width:1000px;
        flex: 1;
        margin-left: 20px;
        .adresslist{
            display: flex;
            align-items: center;
            span{
                margin-right: 20px;
                color: #ff7c00;
                line-height: 25px;
                font-weight: bold;
                font-size: 20px;
                margin-top: 10px;
                i{
                    margin-right: 8px;
                }
            }
        }
        .daycontent{
            width:1100px;
            margin-top: 20px;
            font-size: 16px;
            color: #333333;
            line-height: 40px;
            
            span{
                  width:auto; display:block; white-space:pre-wrap;word-wrap : break-word ;
            }
        }
      
        .daydriving{
            margin-top: 20px;
            font-size: 14px;
            color: #333333;
            background: #f5f5f5;
            padding: 10px;
            line-height: 30px;
            width: 100%;
            span{
                font-weight: bold;
                margin-left: 3px;
            }
        }
    }
}
 .span{
             
        }
</style>